import React from "react";
import { BsTrophyFill } from "react-icons/bs";
import { SiAntdesign } from "react-icons/si";
import { BiCodeAlt } from "react-icons/bi";
import { FaCertificate } from "react-icons/fa";
import { motion } from "framer-motion";

const FunFactCard = ({ icon, des }) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="flex flex-col items-center justify-center p-6 text-center bg-gray-800 rounded-xl border border-gray-700 hover:bg-gray-700 transition-colors"
    >
      <div className="mb-4 text-4xl text-blue-400">
        {icon}
      </div>
      <p className="text-lg font-medium text-gray-300">
        {des}
      </p>
    </motion.div>
  );
};

const FunFact = () => {
  return (
    <section className="py-16 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <FunFactCard
            icon={<BsTrophyFill />}
            des="5 завершенных проектов"
          />
          <FunFactCard
            icon={<SiAntdesign />}
            des="10+ решенных задач"
          />
          <FunFactCard
            icon={<BiCodeAlt />}
            des="500+ часов кодинга"
          />
          <FunFactCard
            icon={<FaCertificate />}
            des="Диплом IT Step"
          />
        </div>
      </div>
    </section>
  );
};

export default FunFact;